import { put, takeLatest, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { userLogged, loginError } from './actions';
import { LOGIN_REQUEST } from './constants';
import { makeSelectCredentials } from './selectors';

function* fetchAgent() {
  const credentials = yield select(makeSelectCredentials());
  credentials.provider = 'agents';
  const requestURL = `${API_URL}login`;

  try {
    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    };

    const response = yield fetch(requestURL, parameters).then(response =>
      response.json(),
    );

    yield put(userLogged(response));
  } catch (err) {
    const error = {
      message: 'Credenziali di accesso errate',
    };
    //loginError(error);
    console.log('request error', err);
  }
}

function* actionWatcher() {
  yield takeLatest(LOGIN_REQUEST, fetchAgent);
}

export default function* quotationData() {
  yield all([actionWatcher()]);
}
